/**
 * Helper JSON-LD pour les pages pannes (extrait du JSX pour éviter
 * le bug Babel "Maximum call stack size exceeded" du plugin visual-edits
 * lors de l'analyse d'objets profondément imbriqués inline).
 */
export const buildPanneSchema = (panne) => ({
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Service",
      serviceType: panne.titleH1,
      name: panne.titleH1,
      description: panne.metaTitle,
      category: panne.category,
      provider: {
        "@type": "LocalBusiness",
        "@id": "https://www.mediastore79.com/#localbusiness",
        name: "Mediastore Niort",
        address: {
          "@type": "PostalAddress",
          streetAddress: "104 Rue de la Gare",
          addressLocality: "Niort",
          postalCode: "79000",
          addressCountry: "FR",
        },
        telephone: "+33549057490",
        url: "https://www.mediastore79.com",
        aggregateRating: {
          "@type": "AggregateRating",
          ratingValue: "4.6",
          reviewCount: "212",
          bestRating: "5",
        },
      },
      areaServed: {
        "@type": "City",
        name: "Niort",
        containedInPlace: { "@type": "AdministrativeArea", name: "Deux-Sèvres" },
      },
      offers: {
        "@type": "AggregateOffer",
        priceCurrency: "EUR",
        lowPrice: String(panne.priceFrom),
        highPrice: String(panne.priceTo),
        offerCount: String(panne.pricing.length),
      },
    },
    {
      "@type": "FAQPage",
      mainEntity: panne.faqs.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    },
  ],
});
